import React, { useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import HomeIcon from "@mui/icons-material/Home";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Restricted from "components/Restricted";
import CountUp from "react-countup";
import clienteAxios from "../../config/clienteAxios";
import axios from "axios";
import * as XLSX from "xlsx";
import { ContentPasteOutlined, EventNote } from "@mui/icons-material";

const ConsolidadoAsistencia = () => {
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const nav = useNavigate();

  //Theme
  const theme = useTheme();

  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    width: isSmallScreen ? "90%" : "40%",
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  //Modal
  const [modalReporte, setModalReporte] = React.useState(false);
  const handleOpenModalReporte = () => setModalReporte(true);
  const handleCloseModalReporte = () => setModalReporte(false);

  //Select States
  const [fechaReporte, setFechaReporte] = React.useState(""); // State to hold the selected year

  // Define the starting year for your report options
  const startYear = 2024; // You can change this to any year you desire
  const currentYear = new Date().getFullYear(); // Get the current year

  // Generate an array of years from startYear to currentYear
  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const handleFechaReporte = (event) => {
    setFechaReporte(event.target.value);
    getAsistenciasConvocatorias(event.target.value);
    getAsistenciasConvocatoriasAnual(event.target.value);
  };

  //BreadCrumbs
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //Routes
  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };

  /////////////////////////////////////////  EXPORTAR A EXCEL  /////////////////////////////////////////////////////
  const downloadReporteExcel = () => {
    const dataSets = [
      {
        sheetName: "Enero",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[0].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Febrero",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[1].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Marzo",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[2].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Abril",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[3].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Mayo",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[4].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Junio",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[5].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Julio",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[6].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Agosto",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[7].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Septiembre",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[8].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Octubre",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[9].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Noviembre",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[10].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Diciembre",
        headers: [
          "Fecha de Convocatoria",
          "Tipo de Convocatoria",
          "Nombre",
          "Apellido",
          "Estatus",
        ],
        data: asistenciasConvocatorias[11].participaciones_voluntarios_del_mes,
      },
      {
        sheetName: "Consolidado Anual",
        headers: [
          "Nombre",
          "Apellido",
          "Total Asistencias",
          "Asistencia Enero",
          "Asistencia Febrero",
          "Asistencia Marzo",
          "Asistencia Abril",
          "Asistencia Mayo",
          "Asistencia Junio",
          "Asistencia Julio",
          "Asistencia Agosto",
          "Asistencia Septiembre",
          "Asistencia Octubre",
          "Asistencia Noviembre",
          "Asistencia Diciembre",
        ],
        data: asistenciasConvocatoriasAnual.resumen_asistencias_voluntario_por_mes,
      },
      // Puedes agregar más conjuntos de datos aquí
    ];

    const wb = XLSX.utils.book_new();

    dataSets.forEach((dataSet) => {
      const ws = XLSX.utils.json_to_sheet([]); // Inicializamos una hoja vacía

      // Agregamos los encabezados en la primera fila
      XLSX.utils.sheet_add_aoa(ws, [dataSet.headers], { origin: "A1" });

      // Agregamos los datos JSON, comenzando en la segunda fila ('A2')
      // y sin omitir la cabecera (ya la agregamos manualmente)
      XLSX.utils.sheet_add_json(ws, dataSet.data, {
        origin: "A2",
        skipHeader: true,
      });

      XLSX.utils.book_append_sheet(wb, ws, dataSet.sheetName);
    });

    XLSX.writeFile(wb, `CONSOLIDADO DE ASISTENCIAS (${fechaReporte}).xlsx`);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const handleLinkAsist = (event, message, row) => {
    let con = JSON.stringify(row.original);
    if (message === "asist") {
      nav(`/asistencia?con=${con}`);
    }
  };

  const handleConsolidadoAsist = (event, message) => {
    if (message === "consolidado") {
      nav("/asistConsolidado");
    }
  };

  const handleLinkGestion = (event, message) => {
    if (message === "gestion") {
      nav("/gestionhumana");
    }
  };

  const handleLinkRetro = (event, message) => {
    if (message === "retro") {
      nav("/retroalimentacion");
    }
  };

  const handleLinkPost = (event, message) => {
    if (message === "post") {
      nav("/postulaciones");
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "nombres", //access nested data with dot notation
        header: "NOMBRE",
        size: 150,
      },
      {
        accessorKey: "apellidos",
        header: "APELLIDO",
        size: 150,
      },
      {
        accessorKey: "ocupacion_descripcion",
        header: "OCUPACIÓN",
        size: 150,
      },
      {
        accessorKey: "total_asistente", //normal accessorKey
        header: "TOTAL ASISTENCIAS",
        size: 200,
      },
      {
        accessorKey: "total_inasistente",
        header: "TOTAL INASISTENCIAS",
        size: 150,
      },
      {
        accessorKey: "total_suplente",
        header: "TOTAL SUPLENCIAS",
        size: 150,
      },
      {
        accessorKey: "total_retrasado",
        header: "TOTAL RETRASOS",
        size: 150,
      },
    ],
    []
  );

  const medicos = [
    { tipo: "Médico General", valor1: 0, valor2: 0 },
    { tipo: "Pediatra", valor1: 5, valor2: 2 },
    { tipo: "Cardiólogo", valor1: 1, valor2: 3 },
  ];

  const [totalAsistencias, settotalAsistencias] = React.useState([]);
  const [totalPorcentajes, settotalPorcentajes] = React.useState([]);
  const [asistenciasConvocatorias, setAsistenciasConvocatorias] =
    React.useState([]);
    const [asistenciasConvocatoriasAnual, setAsistenciasConvocatoriasAnual] =
    React.useState([]);
  const [ejecutar, setEjecutar] = React.useState(true);
  const getTotalAsistencias = async () => {
    try {
      const { data1 } = await axios
        .get("/totalasistencias/")
        .then(function (response) {
          // setAlerta({})
          let equipoRegistrados = response.data;

          settotalAsistencias(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log(error, "error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getTotalPorcentajes = async () => {
    try {
      const { data1 } = await axios
        .get("/totalporcentajes/")
        .then(function (response) {
          // setAlerta({})

          console.log(response.data);
          settotalPorcentajes(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log(error, "error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getAsistenciasConvocatorias = async (dato) => {
    try {
      const { data1 } = await axios
        .get("/voluntariosmeses/", {
          params: {
            anio: dato, // Aquí se envía el año
          },
        })
        .then(function (response) {
          // setAlerta({})

          console.log(response.data[1]);
          setAsistenciasConvocatorias(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log(error, "error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getAsistenciasConvocatoriasAnual = async (dato) => {
    try {
      const { data1 } = await axios
        .get("/voluntariosanual/", {
          params: {
            anio: dato, // Aquí se envía el año
          },
        })
        .then(function (response) {
          // setAlerta({})

          console.log(response.data,"Anual");
          setAsistenciasConvocatoriasAnual(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log(error, "error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  if (ejecutar) {
    getTotalAsistencias();
    getTotalPorcentajes();
  }

  return (
    <Box m="1.5rem 2.5rem">
      {rol === "1" || rol === "2" || rol === "7" ? (
        <>
          <Box
            role="presentation"
            onClick={handleClickBreadCrumbs}
            sx={{ mb: 3 }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/inicio"
                onClick={(event) => handleLinkHome(event, "home")}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Inicio
              </Link>
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/gestionhumana"
                onClick={(event) => handleLinkGestion(event, "gestion")}
              >
                <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
                Gestión Humana
              </Link>
              <Typography
                sx={{ display: "flex", alignItems: "center" }}
                color="text.primary"
              >
                <EventNote sx={{ mr: 0.5 }} fontSize="inherit" />
                Consolidado de Asistencias
              </Typography>
            </Breadcrumbs>
            <Typography variant="h3" sx={{ fontWeight: "bold", mt: 2 }}>
              Consolidado de Asistencias
            </Typography>
            <Box
              mt="10px"
              display="grid"
              gridTemplateColumns="repeat(8, 1fr)"
              gridAutoRows="160px"
              gap="20px"
              sx={{
                "& > div": {
                  gridColumn: isNonMediumScreens ? undefined : "span 12",
                },
              }}
            >
              {/*/////////////////////////////  COLUMNA DE ESTADISTICAS  /////////////////////////////*/}
              <Box
                gridColumn="span 2"
                gridRow="span 4"
                p="1.5rem"
                borderRadius="1.5rem"
                mt="10px"
                height="fit-content"
              >
                <Card
                  sx={{
                    backgroundColor: theme.palette.background.alt,
                    borderRadius: 6,
                    boxShadow: 4,
                  }}
                >
                  <CardHeader
                    title="Estadísticas Generales"
                    //subheader="September 14, 2016"
                    titleTypographyProps={{
                      fontWeight: "bold",
                      fontSize: 18,
                      justifySelf: "center",
                      mt: 2,
                    }}
                  />
                  <CardContent>
                    <Divider>
                      <Chip label="OCUPACION VS ASISTENCIA" size="small" />
                    </Divider>
                    <Box mt={3} mb={3}>
                      <Grid container justifyContent="center">
                        <Grid item xs={5}>
                          <Typography>
                            <b>Ocupación</b>
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography className="text-center">
                            <b>Asistencia</b>
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography className="text-center">
                            <b>Porcentaje</b>
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider />
                      {totalPorcentajes.map((medico, index) => (
                        <Grid container justifyContent="center" key={index}>
                          {" "}
                          {/* Es importante agregar un 'key' único */}
                          <Grid item xs={5}>
                            <Typography>
                              {medico.ocupacion_descripcion}
                            </Typography>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography className="text-center">
                              {medico.cantidad_voluntarios_en_esta_ocupacion}
                            </Typography>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography className="text-center">
                              {
                                medico.porcentaje_del_total_voluntarios_con_ocupacion_valida
                              }
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                      <Divider />
                      <Grid container justifyContent="center">
                        <Grid item xs={5}>
                          <Typography sx={{ bgcolor: "lightgrey" }}>
                            <b>TOTAL</b>
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography
                            sx={{ bgcolor: "lightgrey" }}
                            className="text-center"
                          >
                            <b>
                              {totalPorcentajes.length == 0
                                ? ""
                                : totalPorcentajes[0]
                                    .total_general_voluntarios_con_ocupacion_valida}
                            </b>
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography
                            sx={{ bgcolor: "lightgrey" }}
                            className="text-center"
                          >
                            <b>100%</b>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
              {/*/////////////////////////////  TABLA DE ASISTENCIAS  ////////////////////////////////*/}
              <Box
                gridColumn="span 6"
                gridRow="span 3"
                backgroundColor={theme.palette.background.alt}
                p="1.5rem"
                borderRadius="1.5rem"
                mt={isSmallScreen ? "3px" : "40px"}
                height="fit-content"
                sx={{ boxShadow: 4 }}
              >
                <Grid
                  container
                  spacing={2}
                  mb={2}
                  justifyContent={isSmallScreen ? "center" : ""}
                >
                  <Grid item xs={11} sm={8}>
                    <Typography
                      className={isSmallScreen ? "text-center" : ""}
                      variant="h4"
                      sx={{ fontWeight: "bold" }}
                    >
                      Listado de Asistencia
                    </Typography>
                  </Grid>
                  <Grid item xs={9} sm={4}>
                    <Box
                      container
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<ContentPasteOutlined />}
                        sx={{ bgcolor: "teal", color: "white" }}
                        size="large"
                        onClick={handleOpenModalReporte}
                      >
                        Reportes de Asistencia
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
                <Divider sx={{ mt: 5, mb: 3 }} />
                <MaterialReactTable
                  columns={columns}
                  data={totalAsistencias}
                  localization={MRT_Localization_ES}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableHeadCellProps={{
                    align: "center",
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableBodyProps={{
                    sx: {
                      "& tr:nth-of-type(odd)": {
                        backgroundColor: theme.palette.background.alt,
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    align: "center",
                  }}
                  muiTablePaperProps={{
                    elevation: 0,
                  }}
                  initialState={{
                    pagination: {
                      pageSize: 10,
                      pageIndex: 0,
                    },
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 20, 30, 50, 100],
                    showFirstButton: false,
                    showLastButton: false,
                    SelectProps: {
                      native: true,
                    },
                    labelRowsPerPage: "Número de filas visibles",
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/*//////////////////////////////////  MODAL REPORTES  /////////////////////////////////////*/}
          <Modal
            open={modalReporte}
            onClose={handleCloseModalReporte}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalStyle}>
              <Typography className="text-center" variant="h3" component="h2">
                <b>Reportes de Asistencia</b>
              </Typography>
              <Divider sx={{ mt: 2, mb: 5 }} />
              <Typography className="text-center" variant="h5" mt={1} mb={4}>
                Seleccione un año de la lista para generar el reporte de
                asistencia.
              </Typography>
              <Grid container spacing={2} mb={5} justifyContent="center">
                <Grid item xs={12} sm={5}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel id="report-year-label">
                        Año del Reporte
                      </InputLabel>
                      <Select
                        labelId="report-year-label"
                        id="report-year-select"
                        value={fechaReporte}
                        label="Año del Reporte"
                        onChange={handleFechaReporte}
                      >
                        <MenuItem value="">
                          <em>Seleccionar Dosis...</em>
                        </MenuItem>
                        {years.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "teal", color: "white", height: "100%" }}
                    size="large"
                    fullWidth
                    onClick={downloadReporteExcel}
                    disabled={fechaReporte === ""}
                  >
                    Generar Reporte
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default ConsolidadoAsistencia;
